const PIPELINE = ['New', 'Qualified', 'Discovery', 'Proposal', 'Won'];

// Tradelines/sales targets use the new names
const PIPELINE_TRADELINES = ['New', 'Identified', 'Eligible', 'Quotation Proposal', 'Won'];

// Live migration from old account pipeline names to tradeline names
const PIPELINE_MIGRATION = {
    'Qualified': 'Identified',
    'Discovery': 'Eligible',
    'Proposal': 'Quotation Proposal',
};

function migratePipelineStage(stage) {
    return PIPELINE_MIGRATION[stage] || stage;
}

export { migratePipelineStage, PIPELINE_TRADELINES };

export default PIPELINE;
